// index.ts — entry point for the item-media bundle (IIFE → includes/js/dist/item-media-bundle.js).
//
// Sibling of the catalog-list pattern (docs/catalog-list-pattern.md): instead of fetching a
// catalog, a page drops a <div data-ft-item-media data-ft-media="…"> mount with one item's
// pictures+videos shape embedded up front. This bundle renders both galleries + the uploader and
// pivots between them client-side. Vanilla DOM + fetch only — no jQuery.
//
// Exposes window.ftMountItemMedia() so AJAX-injected mounts can be (re-)hydrated; the
// data-ft-item-media-mounted guard makes re-scans a no-op on already-mounted managers.

import { mountItemMediaAll } from './item-media';
import { mountStandaloneUploaders } from './standalone-uploader';

const mountAll = (): void => {
    mountItemMediaAll();
    mountStandaloneUploaders();
};

Object.assign(window, {
    ftMountItemMedia: mountItemMediaAll,
    ftMountStandaloneUploaders: mountStandaloneUploaders,
});

mountAll();
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mountAll);
}
